
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/tech-prize-highlights",
      function () {
        return require("private-next-pages/blog/tech-prize-highlights.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/tech-prize-highlights"])
      });
    }
  